<template>
    <div
        class="StaticText"
        v-html="staticText"
    />
</template>

<script>
import store from '@/store/store';

export default {
    props: {
        namespace: {
            type: String,
            required: true,
        }
    },

    computed: {
        staticText() {
            return store.state[this.namespace].options.staticText;
        },
    },
};
</script>
<style lang="scss">
.StaticText {
    padding: 18px !important;

    p:last-of-type {
        margin-bottom: 0 !important;
    }

    @media (min-width: 600px) {
        padding: 12px 24px !important;
    }

    @media (min-width: 768px) {
        padding: 12px 36px !important;
    }
}

.StaticText + * {
    margin-top: 18px;
}
</style>
